/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * One observation of a review.
 */
export interface PositionRequestJobAdReviewFinding {
  /**
   * A short label, shown collapsed.
   */
  title?: string | null;
  /**
   * What is wrong, and against which rule, instruction or fact.
   */
  detail?: string | null;
  severity?: PositionRequestJobAdReviewFindingSeverityEnum;
  /**
   * The content item the finding sits in, so it can be marked. Null when it is about the whole job ad.
   */
  itemId?: string | null;
  languageCode?: string | null;
}
export enum PositionRequestJobAdReviewFindingSeverityEnum {
  Unknown = 'Unknown',
  Blocker = 'Blocker',
  Suggestion = 'Suggestion'
}
